import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/** Scrolls window to top on every route change (e.g. blog → variant page). */
export default function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}
